module.exports = __webpack_public_path__ + "static/energy_private_8-388a68c8749b003182bbb4fa81bd83b9.jpg";